module.exports = __webpack_public_path__ + "static/media/true.e2acf8d7.svg";